import { Routes } from '@angular/router';
import { LoggedInAuthGuard } from './auth/auth-default/auth-guards/logged-in-auth.guard';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { LoginComponent } from './auth/app-login/components/login/login.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', canActivate: [LoggedInAuthGuard],  loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: 'profile', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule) },
  { path: '**', component: UnauthorizedComponent }
];
